import { preventBodyScrollClassName } from '../../brunswick/styles/constants'

export function disableScroll(): void {
  document.body.classList.add(preventBodyScrollClassName)
}

export function enableScroll(): void {
  document.body.classList.remove(preventBodyScrollClassName)
}
